import { render, staticRenderFns } from "./service-info.vue?vue&type=template&id=1011f69e&"
import script from "./service-info.vue?vue&type=script&lang=js&"
export * from "./service-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports